import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/registerSW";
import { installAxiosSessionGuard } from "@/lib/axiosSessionGuard";

// Install the global axios interceptor BEFORE React mounts so even the
// AuthProvider's first /auth/me probe is guarded against 401 / corrupted
// sessions. Without this, a stale sandbox token (or any other auth
// drift) would surface as the "Uncaught (in promise) AxiosError 403"
// overlay before any component could call `logout()`.
installAxiosSessionGuard();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the PWA service worker so the app installs to home-screen on
// Android/iOS and survives short offline pulls.
registerServiceWorker();
